<template>
<div :class="$style.surveyPromptWrapper">
    <div v-if="mode!='live'" :class="$style.surveyPromptFieldset">
        <h5 :class="$style.promptTitle">
            Prompt Name: <u>{{prompt.name}}</u>
        </h5>

        <h5 :class="$style.promptTitle">
            Prompt Buttons:
        </h5>

        <v-list dense subheader class="surveyPromptList">
            <template v-for="(button, button_index) in prompt.buttons">
                <v-list-item :key="`${prompt.name}_button_${button_index}`">
                    <v-list-item-avatar>
                        <template v-if="!!button.enabled">
                            <v-icon x-small color="green">
                                fas fa-check-circle
                            </v-icon>
                        </template>
                        <template v-else>
                            <v-icon x-small color="black">
                                fas fa-times-circle
                            </v-icon>
                        </template>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title :class="$style.item_title">
                            {{button_index.substring(0, 1).toUpperCase() + button_index.substring(1)}}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-list>

        <v-list
            dense
            subbheader
            class="surveyPromptList"
            >
            <template v-for="(rule, rule_index) in prompt.rules">
                <v-list-item :key="'rule_'+rule_index">
                    <v-list-item-content>
                        <v-list-item-title :class="$style.item_title">
                            Rule {{rule_index + 1}} Name: <u>{{rule.name}}</u>
                        </v-list-item-title>
                        <template v-if="output && !!output[rule.name+'_'+rule_index].triggered">
                            <v-list-item-subtitle :class="$style.triggered">
                                TRIGGERED
                            </v-list-item-subtitle>
                        </template>
                    </v-list-item-content>
                </v-list-item>

                <v-list dense subheader :key="'rule_'+rule_index + '_condition'" :class="['ml-10', 'surveyPromptList']">
                    <template v-for="(condition, condition_index) in rule.conditions">
                        <v-list-item :key="'condtion_'+condition_index">
                            <v-list-item-avatar>    
                                <v-icon x-small>
                                    fas fa-circle
                                </v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title :class="$style.item_title">
                                    <template v-if="condition.name">
                                        Condition Name: {{condition.name}}
                                    </template>
                                    <template v-else>
                                        Condition {{condition_index + 1}}
                                    </template>
                                </v-list-item-title>
                                <v-list-item-subtitle v-if="!condition.name">
                                    Name is null in the system
                                </v-list-item-subtitle>
                                <template v-if="output && !!output[rule.name+'_'+rule_index][condition.name+'_'+condition_index]">
                                    <v-list-item-subtitle :class="$style.triggered">
                                        TRIGGERED
                                    </v-list-item-subtitle>
                                </template>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list dense subheader :key="'condtion_'+condition_index+'_reference'" :class="['ml-10', 'surveyPromptList']">
                            <v-list-item 
                                    v-for="(condition_reference, condition_reference_index) in filterConditionObjWithNoName(condition)" 
                                    :key="`condition_${condition_index}_${condition_reference_index}`" 
                                    >
                                <v-list-item-avatar>
                                    <template>
                                        <v-icon x-small>
                                            fas fa-circle
                                        </v-icon>
                                    </template>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title :class="$style.item_title">
                                        {{condition_referencesLabel[condition_reference_index]}}: 
                                        <u>{{condition[condition_reference_index] === null ? "Null" : condition[condition_reference_index]}}</u>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </template>
                </v-list>
            </template>
        </v-list>
        
        <div :class="$style.promptLabels_container" v-if="prompt.title.length > 0">
            <template v-for="(label,lang) in prompt.title">
                <div :key="'title_'+lang">
                    <h3 :class="$style.promptSubTitle">
                        {{lang.substring(0, 1).toUpperCase() + lang.substring(1)}}
                    </h3>
                    <div v-for="(content, content_lang) in label['label']" :key="'title_' + lang + '_' + content_lang">
                        <h5 style="display: inline-block;">
                            {{content_lang.substring(0, 1).toUpperCase() + content_lang.substring(1)}} : 
                        </h5>
                        <u style="margin: 5px;padding: 5px;">
                            {{content}}
                        </u>
                    </div>
                </div>
            </template>
        </div>
        
        <div :class="$style.promptLabels_container">
            <h3>Message</h3>
            <template v-for="(label,lang) in prompt.message">
                <div :key="'body_'+lang">
                    <h5 style="display: inline-block;">
                        {{lang.substring(0, 1).toUpperCase() + lang.substring(1)}}:
                    </h5>
                    <u v-html="label" style="margin: 5px;padding: 5px;"/>
                </div>
            </template>
        </div>

    </div>

    <v-dialog v-model='display' :persistent="true" width="600">
        <v-card>
            <v-card-title>
                <v-spacer/><div v-html="prompt.title[$language()]"/><v-spacer/>
            </v-card-title>

            <v-card-text>
                <div v-html="prompt.message[$language()]" style="text-align: center; font-size: 20px;"/>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                    <v-btn color="primary" v-if="prompt.buttons.close.enabled" @click="close">
                        <div :class="$style.surveryPromptBtn" v-if="prompt.buttons.close.label[$language()]" v-html="prompt.buttons.close.label[$language()]"/>
                        <str v-else index="button > close"/>
                    </v-btn>
                    <v-btn color="primary" v-if="prompt.buttons.dismiss.enabled" @click="dismiss">
                        <div :class="$style.surveryPromptBtn" v-if="prompt.buttons.dismiss.label[$language()]" v-html="prompt.buttons.dismiss.label[$language()]"/>
                        <str v-else index="button > close"/>
                    </v-btn>
                    <v-btn color="primary" v-if="prompt.buttons.exit.enabled" @click="exit">
                        <div :class="$style.surveryPromptBtn" v-if="prompt.buttons.exit.label[$language()]" v-html="prompt.buttons.exit.label[$language()]"/>
                        <str v-else index="button > exit"/>
                    </v-btn>
                    <v-btn color="primary" v-if="prompt.buttons.restart.enabled" @click="restart">
                        <div :class="$style.surveryPromptBtn" v-if="prompt.buttons.restart.label[$language()]" v-html="prompt.buttons.restart.label[$language()]"/>
                        <str v-else index="button > restart"/>
                    </v-btn>
                <v-spacer/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import _cloneDeep from 'lodash/cloneDeep';
export default {
    name: 'prompt',
    props: {
        mode: {
            type: String,
            required: false,
            default: 'live'
        },
        prompt: {
            type: Object,
            required: true
        },
        questionMap: {
            type: Object,
            required: true
        },
        answers: {
            type: Object,
            required: true
        },
        promptsLog: {
            type: Object,
            required: true
        }
    },
    data: function(){
        return {
            display: false,
            output: null,
            onClose: {
                clear: []
            },
            timer: null,
            input_delay: null,
            condition_referencesLabel: {
                'equals': "Equals",
                'ref_id': 'Reference Source (QID)',
                'contains': 'Contains',
                'group_id': 'Group ID (Group Selection)',
                'input_id': "Input ID",
                'ref_type': "Reference Type",
                'clear_on_close': "Clear On Close",
                'advanced': "Advanced Function"
            }     
        }
    },
    beforeDestroy: function(){
        this.$emit("prompt_displayed", false)
    },
    methods: {
        close: function(){
            this.onClose.clear.forEach(function(question, index){
                question.controller.clear();
                question.focus();
            });
            this.onClose.clear = [];
            this.display = false;
            this.$emit('close');
        },
        dismiss: function() {
            this.display = false;
            this.$emit('dismiss');
        },
        exit: function(){
            this.$emit('exit');
        },
        restart: function(){
            this.$emit('restart');
        },
        check_prompt: function(){
            var self = this;

            var delay = 0;
            clearTimeout(self.input_delay);
            let promptLog = this.promptsLog[{...this.prompt}.name];
            for(let r=0; r<this.prompt.rules.length; r++){
                var rule = this.prompt.rules[r];
                
                for(let c=0; c<rule.conditions.length; c++){
                    var condition = rule.conditions[c];

                    if(condition.ref_type == 'question'){
                        var question = this.questionMap[condition.ref_id];                        
                        
                        switch(question.config.type){
                            case"Number":case"Percentage":
                                delay = 1200;
                            break;
                        }

                    }
                }
            }

            if((question && question.display) || self.mode=='dev_run_hidden_logics'){// || (self.mode=='dev' || self.mode=='test')
                self.input_delay = setTimeout(function(){
                    let output = {};
                    for(let r=0; r<self.prompt.rules.length; r++){
                        let rule = self.prompt.rules[r];
                        output[rule.name+'_'+r] = {};
                        
                        for(let c=0; c<rule.conditions.length; c++){
                            let condition = rule.conditions[c];
                            output[rule.name+'_'+r][condition.name+'_'+c] = false;
    
                            if(condition.ref_type == 'question'){
                                let question = self.questionMap[condition.ref_id];
    
                                let answer = question.value[condition.group_id];
                                if( condition.group_id && (condition.input_id || condition.contains) ){

                                    if(condition.input_id){
                                        switch(question.config.type){
                                            default:                    
                                                output[rule.name+'_'+r][condition.name+'_'+c] = (answer == condition.input_id);
                                            break;
        
                                            case"Checkbox":
                                                output[rule.name+'_'+r][condition.name+'_'+c] = self.$root.in_array(condition.input_id, answer);
                                            break;
                                        }
                                    }

                                    if(condition.contains){
                                        var search = null;
                                        try {
                                            search = JSON.parse(condition.contains);
                                        } catch (error) {
                                            search = condition.contains;
                                        }

                                        switch(question.config.type){
                                            default:
                                                var search_result = self.$root.in_array(answer, search);
                                                output[rule.name+'_'+r][condition.name+'_'+c] = search_result;
                                            break;
        
                                            case"Checkbox":
                                                output[rule.name+'_'+r][condition.name+'_'+c] = self.$root.in_array(search, answer);
                                            break;
                                        }                                        
                                    }

                                    
    
                                }
    
                                if(typeof condition.advanced == 'function'){
                                    try {
                                        var result = condition.advanced(question, self.questionMap, self.$language(), self);
                                    } catch (error) {
                                        console.error('PROMPT EXECUTION ERROR',{
                                            prompt: self.prompt.name,
                                            rule: rule.name,
                                            error: error
                                        })
                                    }
                                    output[rule.name+'_'+r][condition.name+'_'+c] = result
                                }
    
                                if(output[rule.name+'_'+r][condition.name+'_'+c]===true && condition.clear_on_close){
                                    self.onClose.clear.push(question)
                                }
    
                            }
                        }
                    }
    
                    self.display = false;
                    for(let rule_in in output){
                        var rule = output[rule_in];
                        var triggered = false;
                        if (self.prompt.buttons.dismiss.enabled) {
                            if(promptLog.dismissed > 0) {
                                triggered = false;
                            } else {
                                triggered = self.$root.allTrue(rule);
                            }
                        } else {
                            triggered = self.$root.allTrue(rule);
                        }
                        if(triggered){
                            // if(typeof self.prompt.onTrigger=='function'){
                            //     self.prompt.onTrigger(self.questionMap, self.$language(), self);
                            // }
                            // self.display = prompt.suppress ? true : false;
                            self.display = true;
                            self.$emit('log',{
                                event: 'triggered',
                                rule: rule_in,
                                conditions: rule,
                                prompt_name: self.prompt.name
                            })
                        }
                    }
    
                    self.output = output;
                },delay)
            }

        },
        filterConditionObjWithNoName: function(condition) {
            let cloneCondition = _cloneDeep(condition);
            delete cloneCondition['name'];
            return cloneCondition
        }
    },
    watch: {
        answers: {
            deep: true,
            handler: function(){
                var self = this;
                clearTimeout(this.timer);
                self.timer = setTimeout(function(){
                    self.check_prompt();
                },200)
            }
        },
        display: function(after, before){
            this.$emit("prompt_displayed", after)
        }
    }
}
</script>

<style module>
.surveyPromptWrapper {
    width: 90%; 
    margin: 10px auto 0;
}

.surveyPromptFieldset {
    border: 1px solid lightgrey; 
    background-color: whitesmoke;
    padding: 10px 0;
}

.promptTitle {
    text-align: left;
    font-size: 18px;
    margin-left: 15px;

}

.promptSubTitle {
    text-align: left;
}

.item_title {
    font-weight: 500;
    font-size: 18px;
}

.triggered{
    color: green !important;
    font-weight: bold;
}

.promptLabels_container{
    width: 96%;
    padding: 0 15px 15px 0;
    margin: 0px auto;
}

.surveryPromptBtn p {
    margin-bottom: 0px !important;
}
</style>

<style scoped>
.surveyPromptList .v-list-item {
    min-height: 30px;
    height: 30px;
}
</style>